import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "content"
}
const _hoisted_4 = { class: "shopping-item name 11" }
const _hoisted_5 = {
  key: 2,
  class: "content"
}
const _hoisted_6 = { class: "shopping-item name" }
const _hoisted_7 = ["innerHTML"]

import { t } from '@/plugins/i18n'
import { abnormalDegreeDescList } from '@/common/const'
import { problemHandling, backendProduct, backendProductSku, searchAll, getUserPurchaseAbnormalExtentApi, getUserPurchaseAbnormalPdd, getPlatformOrderItem, getAbnormalDetailApi } from '@/apis/order'
import { computed, ref, toRaw, watch } from 'vue'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'

export default /*#__PURE__*/_defineComponent({
  props: ['rowItem'],
  setup(__props) {

const props = __props

const translateDegree = (key: any) => {
  return abnormalDegreeDescList[key]
}

// 组合直发
// 处理是isgroup 结果是isgroup_result   isgroup_result增加了transformStockStatus入口
const isgroup = computed(() => {
  //      是否直发      是否重拍               采购配置              重拍上限           仓库异常   客户配置         是否是转成囤货单
  const { orderType, purchaseRemakeStatus, purchaseOperateType, reachMaxRemakeTimes, type, payRepurchaseType, transformStockStatus } = props.rowItem
  // if (orderType !== 1 && transformStockStatus !== 1) {
  if (orderType !== 1) {
    return false
  }
  if (type === 7 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 7 && payRepurchaseType === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 0) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  if (type === 10 && reachMaxRemakeTimes === 1 && purchaseRemakeStatus === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 10 && payRepurchaseType === 2 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 10 && purchaseRemakeStatus === 2 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 10 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  return false
})
const isgroupResult = computed(() => {
  //      是否直发      是否重拍               采购配置              重拍上限           仓库异常   客户配置         是否是转成囤货单
  const { orderType, purchaseRemakeStatus, purchaseOperateType, reachMaxRemakeTimes, type, payRepurchaseType, transformStockStatus } = props.rowItem
  if (orderType !== 1 && transformStockStatus !== 1) {
    return false
  }
  if (type === 7 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '$次品重拍达到上限$'
  }
  if (type === 7 && payRepurchaseType === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 0) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  if (type === 10 && reachMaxRemakeTimes === 1 && purchaseRemakeStatus === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 10 && payRepurchaseType === 2 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 10 && purchaseRemakeStatus === 2 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 10 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  return false
})
const showContentList = computed(() => {
  const { type, abnormalDetailType, userExpected, remark, purchaseUserProductLink, changeLinkSellPrice } = props.rowItem
  // ("type 异常类型 1 商品确认 2 全网断货 3 原商品缺货 4 预售商品 5 不满足最小起订量 6 更换采购链接 7 次品件 8 异常次品件 9 客户退款 10 到错货 11 多件 12 少件 13 扫不出 14 商品下架 15 商品异常")
  switch (type) {
    case 1:
      switch (abnormalDetailType) {
        case 1:
          return [t('确认尺码')]
        case 2:
          return [t('确认颜色')]
        case 3:
          return [t('确认款式')]
        case 14:
          return [t('无法按拼团价进行采购，需按原价进行采购')]
        default:
          return []
      }
    case 2:
      return [t('全网断货')]
    case 3:
      switch (abnormalDetailType) {
        case 4:
          return !userExpected ? [t('原商品缺货-推荐同款-价格不符合客户预期').replace('X', checkedProduct.value?.price ?? 0).replaceAll('H', purchaseUserProductLink)] : []
        case 5:
          return [t('原商品缺货-推荐类似款').replace('X', checkedProduct.value?.price ?? 0).replaceAll('H', purchaseUserProductLink)]
        default:
          return []
      }
    case 4:
      switch (abnormalDetailType) {
        case 4:
          return [t('预售商品-推荐同款商品').replace('X', remark ?? 0).replaceAll('H', purchaseUserProductLink)]
        case 6:
          return [t('预售商品-无同款商品推荐').replace('X', remark ?? 0)]
        default:
          return []
      }
    case 5:
      switch (abnormalDetailType) {
        case 4:
          return [t('不满足最小起量-推荐同款商品').replace('X', remark ?? 0).replace('Y', props.rowItem.num).replaceAll('H', purchaseUserProductLink)]
        case 6:
          return [t('不满足最小起量-无同款商品推荐').replace('X', remark ?? 0).replace('Y', props.rowItem.num)]
        default:
          return []
      }
    case 6:
      return !userExpected ? [t('更换同款链接-价格不符合客户预期').replaceAll('H', purchaseUserProductLink)] : []
    case 7:
    case 8:
      return getDefectiveProductContent()
    case 10:
      // 未配置次品付费重拍和配置文案区分
      return [(isHaveShopPurchase.value === 0 ? t('因原商品质量不佳，我们为您自动寻找了以下新链接，请您确认是否需要再新链接下重拍') : t('因原商品质量不佳，我们为您重拍时自动寻找了以下新链接，但新链接价格不符合您的预期，请您确认')).replace('X', productSellPrice.value).replaceAll('H', purchaseUserProductLink)]
    case 12:
      return [t('原URL缺货，新的URL内商品是X元，请确认').replace('X', productSellPrice.value).replaceAll('H', purchaseUserProductLink)]
    default:
      return []
  }
})

const isHaveShopPurchase = ref(0)
const checkedProduct: any = ref()
const productSellPrice = ref('')
const productSkuList: any = ref([])
// 获取采购商品详情
const getBackendProductSku = () => {
  const { purchaseUserProductSku } = toRaw(props.rowItem)
  backendProductSku({
    productSku: purchaseUserProductSku
  }).then((res: any) => {
    for (const e of (res.data.skuList || [])) {
      if (e.productSku === purchaseUserProductSku) {
        console.log('e', e)
        const properties = e.productPropertiesName.split(';').map((v: any) => v.replace(/[+-]?\d+:[+-]?\d+:/, ''))
        checkedProduct.value = {
          productSku: e.productSku,
          productCode: e.productCode,
          props: properties.join(' '),
          link: res.data.productDetailUrl,
          price: e.productSellPrice
        }
        break
      }
    }
  })
}
const getBackendProduct = () => {
  const { productCode, productSku } = toRaw(props.rowItem)
  backendProduct({
    productCode
  }).then(res => {
    const list = (res.data.skuList || []).map((e: any) => {
      const properties = e.productPropertiesName.split(';').map((v: any) => v.replace(/[+-]?\d+:[+-]?\d+:/, ''))
      if (e.productSku === productSku) {
        checkedProduct.value = {
          productSku: e.productSku,
          productCode: e.productCode,
          props: properties.join(' '),
          link: res.data.productDetailUrl
        }
      }
      return ({
        productSku: e.productSku,
        productCode: e.productCode,
        props: properties.join(' '),
        link: res.data.productDetailUrl
      })
    })
    productSkuList.value = list
  })
}
if (props.rowItem.type === 8 || props.rowItem.type === 12 || props.rowItem.type === 10) {
  // 获取状态和价格
  getUserPurchaseAbnormalExtentApi({
    purchaseAbnormalOrderId: props.rowItem.purchaseAbnormalOrderId
  }).then((res: any) => {
    isHaveShopPurchase.value = res.data.isHaveShopPurchase
    productSellPrice.value = res.data.productSellPrice
  })
}// 仓库次品登记
const defectiveAbnormalDictFlaw: any = {
  101: t('到错货'),
  102: t('少件'),
  103: t('多件'),
  104: t('快递扫不出'),
  201: t('颜色差异'),
  202: t('商品上有中文'),
  203: t('配件差异'),
  204: t('logo差异'),
  205: t('尺码差异'),
  206: t('设计差异'),
  207: t('材质、面料差异'),
  301: t('$色差$'),
  302: t('$污渍/斑点/水印$'),
  303: t('$破损$'),
  304: t('$线头$'),
  305: t('$接缝不良$'),
  306: t('$抽丝$'),
  307: t('$针眼$'),
  308: t('$霉菌$'),
  309: t('$生锈$'),
  310: t('$商品有中文$'),
  311: t('$纽扣破损$'),
  312: t('$拉链破损$'),
  313: t('$附属品缺陷$'),
  314: t('$有气味$'),
  315: t('$其他不良$'),
  316: t('$通电不良$')
}

// 仓库异常上报客户
const defectiveAbnormalDictAbnormal: any = {
  101: t('到错货'),
  102: t('少件'),
  103: t('多件'),
  104: t('快递扫不出'),
  201: t('颜色差异'),
  202: t('商品上有中文'),
  203: t('配件差异'),
  204: t('logo差异'),
  205: t('尺码差异'),
  206: t('设计差异'),
  207: t('材质、面料差异'),
  301: t('$色差$2'),
  302: t('$污渍/斑点/水印$2'),
  303: t('$破损$2'),
  304: t('$线头$2'),
  305: t('$接缝不良$2'),
  306: t('$抽丝$2'),
  307: t('$针眼$2'),
  308: t('$霉菌$2'),
  309: t('$生锈$2'),
  310: t('$商品有中文$2'),
  311: t('$纽扣破损$2'),
  312: t('$拉链破损$2'),
  313: t('$附属品缺陷$2'),
  314: t('$有气味$2'),
  315: t('$其他不良$2'),
  316: t('$通电不良$2')
}
const defectiveAbnormalDict = computed(() => {
  return props.rowItem.type === 8 ? defectiveAbnormalDictAbnormal : defectiveAbnormalDictFlaw
})
const getDefectiveProductContent = () => {
  const { abnormalDetailMessageJp } = props.rowItem
  const content: string[] = []
  abnormalDetailMessageJp?.split(',')?.forEach((e: string) => {
    content.push(defectiveAbnormalDict.value[e] || '')
  })
  // console.log('111', t('$色差$'))
  return content
}

if ([1, 2, 3].includes(props.rowItem.abnormalDetailType)) {
  getBackendProduct()
}
if ([4, 5].includes(props.rowItem.abnormalDetailType)) {
  getBackendProductSku()
}
if (props.rowItem.type === 8 || props.rowItem.type === 12 || props.rowItem.type === 10) {
  // 获取状态和价格
  getUserPurchaseAbnormalExtentApi({
    purchaseAbnormalOrderId: props.rowItem.purchaseAbnormalOrderId
  }).then((res: any) => {
    isHaveShopPurchase.value = res.data.isHaveShopPurchase
    productSellPrice.value = res.data.productSellPrice
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.rowItem.abnormalDetailMessageSeverity)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rowItem.abnormalDetailMessageSeverity, (i, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createTextVNode(_toDisplayString(translateDegree(i.abnormalCode)) + " - " + _toDisplayString(translateDegree(i.abnormalSeverityCode)) + " ", 1),
              (index != __props.rowItem.abnormalDetailMessageSeverity.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, ";"))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_unref(isgroupResult))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)(_unref(isgroupResult)).replace('元', _unref(showCurrentUnit)(__props.rowItem.supplierCountry === _unref(COUNTRY).KR))), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showContentList), (l) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: l,
                  style: {"margin":"0"}
                }, [
                  _createElementVNode("span", {
                    innerHTML: l.replace('元', _unref(showCurrentUnit)(__props.rowItem.supplierCountry === _unref(COUNTRY).KR)),
                    style: {"word-break":"break-all","line-height":"1.5"}
                  }, null, 8, _hoisted_7)
                ]))
              }), 128))
            ])
          ]))
  ]))
}
}

})